export const candidateExternal = {
  success: true,
  data: [
    {
      id: "82178e39-9109-47de-af01-fa6e38dda40f",
      firstName: "Anthonia",
      middleName: null,
      lastName: "Egbuniwe",
      email: "egbuniweanthonia@gmail.com",
      phone: "+2349063635574",
      professionalTitle: "Marketing Ops Specialist/ Hubspot specialist",
      yearsOfExperience: 5,
      city: "Lagos",
      state: "Ogun",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      preferredWorkArrangement: null,
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      rating: null,
      fitScore: null,
      isActive: true,
      photoUrl: null,
      passportImageUrl: null,
      createdAt: "2026-02-04T18:45:46.521Z",
      updatedAt: "2026-02-04T18:46:23.685Z",
      _count: {
        applications: 0,
        interviews: 0,
      },
      location: {
        city: "Lagos",
        state: "Ogun",
        country: "Nigeria",
      },
      overallRating: 3.4,
    },
    {
      id: "535d36af-b4c1-41c2-ae25-35bc85af0ad9",
      firstName: "Matthew",
      middleName: null,
      lastName: "Ogwuche",
      email: "mattpraise2020@gmail.com",
      phone: "08061179631",
      professionalTitle: "Sales Executive",
      yearsOfExperience: 8,
      city: "Lagos",
      state: "Lagos",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      preferredWorkArrangement: null,
      sourceChannel: "DIRECT_APPLICATION",
      tags: [],
      rating: null,
      fitScore: null,
      isActive: true,
      photoUrl: null,
      passportImageUrl:
        "https://pub-6ada45ade4ee412f87a8b6e1ec2c4c07.r2.dev/candidates/535d36af-b4c1-41c2-ae25-35bc85af0ad9/passport/1769787715127-4732597e34220639-passport1.jpg",
      createdAt: "2026-01-30T15:40:53.599Z",
      updatedAt: "2026-01-30T15:47:38.755Z",
      _count: {
        applications: 0,
        interviews: 0,
      },
      location: {
        city: "Lagos",
        state: "Lagos",
        country: "Nigeria",
      },
      overallRating: 3.9,
    },
    {
      id: "da1d9f3f-3922-46e6-a7af-e51233a232ef",
      firstName: "Juliet ",
      lastName: "Egbuniwe",
      email: "julietijeomaegbuniwe@gmail.com",
      phone: "08160502190",
      professionalTitle: "Marketing Executive",
      yearsOfExperience: 10,
      summary:
        "Marketing and growth executive with nearly 10 years of experience leading strategy execution, automation design, and full customer-journey mapping and development across multiple CRMs. I specialize in building end to end marketing operations, with deep expertise in HubSpot, Mailchimp, Klaviyo, ClickUp and others for workflow automation, lifecycle nurturing, and campaign management. My background includes strong SEO foundations, high-level strategy implementation, and the ability to make complex growth goals into practical actions.",
      city: "Abuja",
      state: "Abuja",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 3.8,
      interviewRating: null,
      cvJobMatchRating: null,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: null,
      rateStatus: "UNRATED",
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      isActive: true,
      skills: [
        {
          id: "1883e883-5c01-43ed-ac1d-6109c51901d0",
          skillName: "Marketing Automation",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "59debcd2-fd57-47ff-acf5-0bb2543c3afb",
          skillName: "HubSpot",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "09d8b129-9576-44cf-81b2-fe6e67378599",
          skillName: "ClickUp",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "0fa3cc30-9039-4b3b-8c61-542bcd67c66c",
          skillName: "CRM",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "0cf5ccf5-37ee-40a9-ac84-f617f4a72082",
          skillName: "SEO",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "4d91d945-d614-4c4b-a9b1-5aeed4624feb",
          skillName: "Canva",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "81c8ac26-896b-4c11-a83d-d643cb86e53e",
          skillName: "SEMrush",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "0b0bd597-6099-4b91-a6b3-ef723b0d19bf",
          skillName: "Google Analytics",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "4c131e69-b005-4394-91a7-92014fe35172",
          skillName: "Google Search Console",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "a9556069-8681-488f-89bb-7f6ede8ed871",
          skillName: "Sales Funnel Knowledge",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "118d57b4-0dc5-49bc-b58b-889892937905",
          skillName: "Workflow optimization",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "534c8526-644c-42ca-9328-bdd33696ce8c",
          skillName: "Business Acumen",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e9f55f16-0023-4fde-934d-02642ce90f50",
          skillName: "Customer-centric mindset",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e1545334-7acb-410a-9a53-a10b9665ebee",
          skillName: "Data Analysis",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "0dd600e6-eb38-41bc-a07f-30f140822baf",
          skillName: "Google Workspace",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b09f596e-3b8f-459c-a0e9-b5cb13d40a75",
          skillName: "Microsoft Office Suite",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ab7b078d-e5cc-40ef-b0d0-de2d36808d5d",
          skillName: "Meta Ads Manager",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "1eae2317-e76f-47bb-b1a2-32027680fb32",
          skillName: "Adobe Audition",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "8dcd3f3a-b86c-4c50-9c41-e54802d94205",
          skillName: "Google Data Studio",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b9254576-4742-42e5-b99b-4e5f318013d5",
          skillName: "Asana",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "70de9401-1c7b-4d95-88cb-cf04afdea673",
          skillName: "Adobe Illustrator",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "f6dd25d6-9a83-4253-a5b1-233083ea4432",
          skillName: "Grammarly",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ad175980-e938-42d3-8f30-4680c653e9ec",
          skillName: "Trello",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5aaefa04-9b5c-47bd-ab36-b9c4aa5fa4a7",
          skillName: "Klaviyo",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "7aa8f6b7-bd26-4f7b-95aa-4fb4e6807ce3",
          skillName: "Mailchimp",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "26dc493b-746b-4ea8-b165-6b82d96c42b9",
          skillName: "CapCut",
          level: "BEGINNER",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
      ],
      certifications: [
        {
          id: "c8c57e2d-7783-4f51-9bd6-0b9e262e1b50",
          name: "Content marketing",
          issuingOrganization: "Hubspot Academy",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: true,
          isVerified: false,
        },
        {
          id: "d518031d-9113-41d9-92a4-52261dfba4df",
          name: "Social media marketing",
          issuingOrganization: "Hubspot Academy",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: true,
          isVerified: false,
        },
        {
          id: "5217802d-06c4-45dd-ab5a-faaf160176f4",
          name: "SEO",
          issuingOrganization: "Hubspot Academy",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: true,
          isVerified: false,
        },
        {
          id: "4601de16-4dc2-4f14-9a43-c7f5d81030c3",
          name: "Hubspot reporting",
          issuingOrganization: "Hubspot Academy",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: true,
          isVerified: false,
        },
        {
          id: "852698fb-d7fc-49f4-a244-fb78a1956311",
          name: "Inbound marketing",
          issuingOrganization: "Hubspot Academy",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: true,
          isVerified: false,
        },
        {
          id: "0dfe73be-1eaa-4e31-b4bb-f8978886c3da",
          name: "Inbound marketing optimization",
          issuingOrganization: "Hubspot Academy",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: true,
          isVerified: false,
        },
        {
          id: "b2e06528-5ff7-4cb0-bc86-656a7a9f6998",
          name: "Content marketing principles for business",
          issuingOrganization: "Semrush",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: true,
          isVerified: false,
        },
        {
          id: "e8cdc5b2-9f04-400c-bc7e-1cacd04b7516",
          name: "International SEO",
          issuingOrganization: "Semrush",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: true,
          isVerified: false,
        },
      ],
      education: [
        {
          id: "2ca9c1d3-1c91-4dd7-bfab-25d766a8bc55",
          institutionName: "Nnamdi Azikiwe University",
          degree: "B.ENG in Electrical Engineering",
          educationLevel: "BACHELOR",
          fieldOfStudy: "Electrical Engineering",
          startDate: null,
          endDate: null,
          isCurrentlyStudying: false,
          isVerified: false,
        },
      ],
      languages: [
        {
          id: "4411bcb5-9ed6-4812-add6-4ea94a8afa20",
          languageName: "English",
          proficiency: "NATIVE",
          isNative: true,
        },
        {
          id: "775546eb-41ed-477e-a294-94c80549caff",
          languageName: "French",
          proficiency: "CONVERSATIONAL",
          isNative: false,
        },
        {
          id: "fb2561c8-4ec4-4cd4-beee-dc2d2638d7d7",
          languageName: "Spanish",
          proficiency: "BASIC",
          isNative: false,
        },
      ],
      createdAt: "2026-01-29T09:23:41.587Z",
      updatedAt: "2026-01-29T09:24:02.567Z",
      location: {
        city: "Abuja",
        state: "Abuja",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: {
        level: "BACHELOR",
        degree: "B.ENG in Electrical Engineering",
        fieldOfStudy: "Electrical Engineering",
        institution: "Nnamdi Azikiwe University",
      },
    },
    {
      id: "1bdb611a-ca44-474a-b19a-837dd5d67256",
      firstName: "Esther",
      lastName: "Adama",
      email: "eenechojo@gmail.com",
      phone: "08161135176",
      professionalTitle: "DevOPs",
      yearsOfExperience: 2,
      summary: "",
      city: "Kaduna",
      state: "Kaduna",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 3.3,
      interviewRating: null,
      cvJobMatchRating: null,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: null,
      rateStatus: "UNRATED",
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      isActive: true,
      skills: [],
      certifications: [],
      education: [],
      languages: [],
      createdAt: "2026-01-12T10:29:03.164Z",
      updatedAt: "2026-01-12T10:29:03.164Z",
      location: {
        city: "Kaduna",
        state: "Kaduna",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: null,
    },
    {
      id: "23d21458-80dc-4fb3-acc9-12bd494465f7",
      firstName: "Christian",
      lastName: "Monte",
      email: "mayormontechris2966@gmail.com",
      phone: "+2348144784467",
      professionalTitle: "User Experience Designer",
      yearsOfExperience: 4,
      summary: "",
      city: "Kaduna",
      state: "Kaduna",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 4.3,
      interviewRating: null,
      cvJobMatchRating: null,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: null,
      rateStatus: "UNRATED",
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      isActive: true,
      skills: [],
      certifications: [],
      education: [],
      languages: [],
      createdAt: "2026-01-12T10:17:16.166Z",
      updatedAt: "2026-01-12T10:17:16.166Z",
      location: {
        city: "Kaduna",
        state: "Kaduna",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: null,
    },
    {
      id: "d82f7737-960d-4d36-823b-e215a7ae099c",
      firstName: "KEHINDE ",
      lastName: "EMORUWA ",
      email: "babafemi_kehinde@yahoo.com",
      phone: "07065230409",
      professionalTitle: "Group Security Manager",
      yearsOfExperience: 19,
      summary:
        "Results Oriented Group Security Manager with over 19 years of experience in developing and implementing comprehensive security protocols, proven track record in managing security operations, conducting risk assessments and collaborating with cross-functional teams. Skilled in crisis management, emergency response planning and security training. Strong leadership abilities with a focus on managing a safe and secure environment.",
      city: "Ikorodu",
      state: "Lagos",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 2.6,
      interviewRating: null,
      cvJobMatchRating: 2.1,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: 34,
      rateStatus: "RATED",
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      isActive: true,
      skills: [
        {
          id: "8d9fa716-6893-4b0d-8462-3c05f4256749",
          skillName: "Security Operations",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "04e00fef-16f8-4c77-8676-98df1dac5ddb",
          skillName: "Emergency Response Planning",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "2aa37e8d-6912-4bf0-bb37-294a3936739b",
          skillName: "Risk Assessment Analysis",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "768f8929-3da4-43cf-bd14-ea59af6f5601",
          skillName: "Vulnerability assessment",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "bfdf911a-b46e-4d0f-aafd-82f104365937",
          skillName: "Crisis management",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b98882b1-5b3f-49fe-a59a-6fb4a48c0dbc",
          skillName: "Security Policies and Procedures",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "827c01e8-dd89-457c-957d-51275f0663a0",
          skillName: "Team Management",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "c639a961-7793-4658-ade9-47640ab9be8e",
          skillName: "Investigations",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "54ef0547-0580-41ea-9be4-afb073e04f36",
          skillName: "Collaboration",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "fd97c906-2459-4fd2-a1fe-2b8c02c34767",
          skillName: "Leadership",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ddf2617b-537b-49cc-acde-7a506e0bc63d",
          skillName: "Security Training",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
      ],
      certifications: [
        {
          id: "3ac4006b-162c-4ba8-81af-8ed815906346",
          name: "CERTIFICATE OF COMPETENCE",
          issuingOrganization: "NIGERIAN RED CROSS SOCIETY",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
        {
          id: "3ec486ef-d0ba-4d90-b767-ae18aebcfa8f",
          name: "HSE- [LEVEL 3], ADVANCED CERTIFICATE",
          issuingOrganization: "NIGERIAN INSTITUTE OF SAFETY PROFESSIONALS.",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
        {
          id: "415171c5-d0d6-4a61-be0a-fcd0ea5a86dd",
          name: "HSE-COMPETENCE-DEVELOPMENT- CERTIFICATE [LEVEL 2]",
          issuingOrganization: "NIGERIAN INSTITUTE OF SAFETY PROFESSIONALS.",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
        {
          id: "9c272e20-e75b-4273-b167-53e6462c8f75",
          name: "CERTIFIED SECURITY SPECIALIST [IN VIEW]",
          issuingOrganization: "NIGERIAN INSTITUTE OF INDUSTRIAL SECURITY",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
        {
          id: "ec6338d1-36a4-4044-a478-a9a45d69ddf4",
          name: "CERTIFIED FIRST AID AND CPR TRAINING",
          issuingOrganization: "NIGERIAN RED CROSS SOCIETY",
          issueDate: null,
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
      ],
      education: [
        {
          id: "d9767a14-b935-4ef0-ba25-4f48b99ab419",
          institutionName: "INSTITUTION-PETROLEUM TRAINING INSTITUTE, WARRI",
          degree: "HIGHER NATIONAL DIPLOMA",
          educationLevel: "PROFESSIONAL",
          fieldOfStudy: "PETROLEUM ENGINEERING",
          startDate: "2000-01-01T00:00:00.000Z",
          endDate: "2002-01-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
        {
          id: "d65aa11c-f212-449f-bc0a-fd31e925c2d2",
          institutionName: "INSTITUTION-PETROLEUM TRAINING INSTITUTE, WARRI",
          degree: "NATIONAL DIPLOΜΑ",
          educationLevel: "PROFESSIONAL",
          fieldOfStudy: "MINERAL RESOURCES ENGINEERING",
          startDate: "1996-01-01T00:00:00.000Z",
          endDate: "1998-01-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
      ],
      languages: [],
      createdAt: "2026-01-12T04:24:30.814Z",
      updatedAt: "2026-01-22T07:33:28.629Z",
      location: {
        city: "Ikorodu",
        state: "Lagos",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: {
        level: "PROFESSIONAL",
        degree: "HIGHER NATIONAL DIPLOMA",
        fieldOfStudy: "PETROLEUM ENGINEERING",
        institution: "INSTITUTION-PETROLEUM TRAINING INSTITUTE, WARRI",
      },
    },
    {
      id: "25150adb-8b9f-45ff-aa98-bf05c61c4454",
      firstName: "AKPEVWEOGHENE",
      lastName: "UGONO",
      email: "aes_akpe@yahoo.ca",
      phone: "+2348108588599",
      professionalTitle: "Sales Executive",
      yearsOfExperience: 2,
      summary: "",
      city: "Alimosho",
      state: "Lagos",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 2.9,
      interviewRating: null,
      cvJobMatchRating: 1,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: 0,
      rateStatus: "RATED",
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      isActive: true,
      skills: [],
      certifications: [],
      education: [],
      languages: [],
      createdAt: "2026-01-10T00:10:23.034Z",
      updatedAt: "2026-01-16T17:58:50.998Z",
      location: {
        city: "Alimosho",
        state: "Lagos",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: null,
    },
    {
      id: "1c019b51-9001-4ec8-9686-8364081404a9",
      firstName: "Ijeoma",
      lastName: "Igwilo",
      email: "ijeomapatie@gmail.com",
      phone: "08106368460",
      professionalTitle: "Data Entry Officer",
      yearsOfExperience: 3,
      summary: "",
      city: "Abule egba",
      state: "Lagos",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 3.7,
      interviewRating: null,
      cvJobMatchRating: null,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: null,
      rateStatus: "UNRATED",
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      isActive: true,
      skills: [],
      certifications: [],
      education: [],
      languages: [],
      createdAt: "2026-01-09T09:03:31.890Z",
      updatedAt: "2026-01-09T09:03:31.890Z",
      location: {
        city: "Abule Egba",
        state: "Lagos",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: null,
    },
    {
      id: "580c61ed-4e03-4630-887b-7a0782205e17",
      firstName: "JULIET",
      lastName: "CLEMENT",
      email: "clementjuliet50@gmail.com",
      phone: "08050482430",
      professionalTitle: "Customer Service Professional",
      yearsOfExperience: 4,
      summary:
        "Dedicated and empathetic customer service professional with proven experience in efficiently handling customer inquiries, resolving issues, and ensuring high levels of customer satisfaction. Skilled in communication, problem-solving, and maintaining accurate records. My background in managing sensitive customer interactions positions me as a strong candidate for HR support roles.",
      city: "Lagos",
      state: "Lagos",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 3.5,
      interviewRating: 4,
      cvJobMatchRating: 2.1,
      manualHrRating: 3,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: 33,
      rateStatus: "RATED",
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      isActive: true,
      skills: [
        {
          id: "97dc0e59-60ff-4b1f-873f-44341b474d25",
          skillName: "Team dynamics",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "fbf08a8b-e52c-45ac-9617-e57689a09580",
          skillName: "Confidentiality handling",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "8fad29fe-14a0-4f54-9757-a22c1a1b7e46",
          skillName: "Onboarding assistance",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "65ae3468-b640-4f03-81e2-80f7faa9ff78",
          skillName: "Record keeping",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "9d5c6e2c-c09e-4c97-9ba0-193ab99b8ca8",
          skillName: "Inbound/outbound call Handling",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "4d6cf2c3-834e-41df-84bb-03586f9fffef",
          skillName: "Customer relations management",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5c623292-808f-469f-845c-42229207bd06",
          skillName: "Mediation",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "24fd5901-0734-4436-adbc-07732d2a0170",
          skillName: "Interpersonal communication",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "2bf6bad5-9da1-4216-a0c0-fe0d7e862c0a",
          skillName: "Active listening",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5b39ff73-16e3-4f5d-935e-34d664cbbbc6",
          skillName: "Team collaboration",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "183bfcd3-7380-4af1-aa6b-48c21d75a704",
          skillName: "Documentation",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "4e937cf2-3b86-44d4-a598-7419402c59fe",
          skillName: "Conflict resolution",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "3c0670a1-e179-4d22-af8e-2df12cefb5ba",
          skillName: "Multitasking",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "31e4d073-b60b-46ab-8606-955d527c10a6",
          skillName: "Employee engagement",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
      ],
      certifications: [],
      education: [
        {
          id: "c2ac34b8-8fe1-43fe-a8bb-35c73869725a",
          institutionName: "Lagos State Polytechnic, Isolo Lagos",
          degree: "Higher National Diploma in Accounting",
          educationLevel: "ASSOCIATE",
          fieldOfStudy: "Accounting",
          startDate: "2019-01-01T00:00:00.000Z",
          endDate: "2022-12-31T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
        {
          id: "6037f4ed-5829-463d-a7b9-3dae8ee6ba60",
          institutionName: "Lagos State Polytechnic, Isolo Lagos",
          degree: "National Diploma in Accounting",
          educationLevel: "ASSOCIATE",
          fieldOfStudy: "Accounting",
          startDate: "2016-01-01T00:00:00.000Z",
          endDate: "2019-12-31T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
        {
          id: "52ff6e95-fbd6-4d88-a82c-14e669820de5",
          institutionName: "El- Shaddai Secondary School",
          degree: "West African Senior School Certificate",
          educationLevel: "HIGH_SCHOOL",
          fieldOfStudy: null,
          startDate: "2012-01-01T00:00:00.000Z",
          endDate: "2015-12-31T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
      ],
      languages: [],
      createdAt: "2026-01-08T11:11:46.193Z",
      updatedAt: "2026-01-08T15:03:46.797Z",
      location: {
        city: "Lagos",
        state: "Lagos",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: {
        level: "ASSOCIATE",
        degree: "Higher National Diploma in Accounting",
        fieldOfStudy: "Accounting",
        institution: "Lagos State Polytechnic, Isolo Lagos",
      },
    },
    {
      id: "4e0d4bca-a0b8-4ce2-94fb-e0afaf5ad9ff",
      firstName: "Princewill",
      lastName: "Nwaogazi",
      email: "greatprincewill@yahoo.com",
      phone: "08038186977",
      professionalTitle: "Talent Acquisition Specialist",
      yearsOfExperience: 8,
      summary:
        "Strategic Talent Acquisition Specialist with 8 years of experience in full-cycle recruitment. Skilled in leveraging diverse sourcing channels to build talent pipelines, resulting in a 25% increase in successful placements.",
      city: "Abule Egba",
      state: "Lagos",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 2.8,
      interviewRating: null,
      cvJobMatchRating: 2.2,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: 37,
      rateStatus: "RATED",
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      isActive: true,
      skills: [
        {
          id: "02edfdaf-f6c1-4436-bdd0-21497d340746",
          skillName: "LinkedIn Recruiter",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "77c14f15-fb60-48aa-907a-9c474751d6c8",
          skillName: "Client Relationship Management",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "9fa4a901-260b-40dc-bbaa-7380b015c3ab",
          skillName: "Applicant Tracking Systems (ATS)",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "97e538d3-f1e5-46e6-8045-43e4b95eb21b",
          skillName: "Talent Pipelining",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "459d19b6-1c75-4999-ac22-aa3a81ff316b",
          skillName: "Talent Acquisition",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e8606842-f602-472e-8a03-9f0447aafa45",
          skillName: "Recruitment Strategies",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ea452499-aa14-4803-be0b-92a15143c636",
          skillName: "Proficiency",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ca09c665-89a4-4346-9624-c52d4fa6ab64",
          skillName: "Negotiation Skills",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5fb552eb-4f5f-4088-b8d2-8eaa34b6414a",
          skillName: "Compliance & Diversity Hiring",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "493f67d3-de87-4e0e-a824-b6365ba9eca5",
          skillName: "Employer Branding",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "67b92ff3-7df3-43a5-bac7-9955e8c5de91",
          skillName: "HR Tools",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "c76d78ad-a8b5-47a0-bc71-a0431706f3cb",
          skillName: "Market Research",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "db47c1a3-7dc7-4ae2-876d-a12c2aa61910",
          skillName: "Recruitment Analytics",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "f3f95f4f-085c-4a0e-bce8-eac258cc28f3",
          skillName: "Social Media Recruiting",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d097c798-77d9-4993-9ab1-3fd2b722b99d",
          skillName: "Succession Management",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "02b60a75-19ef-45c1-9dbe-5b56cc8a06b0",
          skillName: "Team Leadership",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "a0ea3e75-aa2f-4c3d-97a1-2a9527a17a1c",
          skillName: "Training",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d31e1234-d378-45b7-8a99-1b5222e81015",
          skillName: "Workforce Planning",
          level: "ADVANCED",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "2f4989ef-97e1-4ce2-9958-03570fc7d8ab",
          skillName: "Teamtailor",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "a1edab62-6fa2-4547-8800-d934291dfb6e",
          skillName: "HiBob",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "2091fcb6-0ff8-4eba-9779-9d71d36a95dc",
          skillName: "KRIS",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "525023af-d607-4007-8689-92a6dd57ab83",
          skillName: "Kracada",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "865deeb8-9fb3-4036-b22f-6c987a399be8",
          skillName: "Zoho Recruit",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
      ],
      certifications: [
        {
          id: "1b64cca3-7093-415f-9cc5-0a71639f6953",
          name: "Chartered Institute of Personnel Management (CIPM): Associate Member - Licensed HR CIPM/HRPL/000809",
          issuingOrganization:
            "Chartered Institute of Personnel Management (CIPM)",
          issueDate: "2015-01-01T00:00:00.000Z",
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
        {
          id: "5f0fcdd7-c546-4932-8b7c-681b624a6f38",
          name: "Nigeria Institute of Management (NIM), Graduate Member",
          issuingOrganization: "Nigeria Institute of Management (NIM)",
          issueDate: "2008-01-01T00:00:00.000Z",
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
      ],
      education: [
        {
          id: "422172a1-7ceb-4e51-b501-80a6fe1c873a",
          institutionName: "Abia State University",
          degree: "Bachelor of Arts",
          educationLevel: "BACHELOR",
          fieldOfStudy: "English Language and Literature",
          startDate: "2006-01-01T00:00:00.000Z",
          endDate: null,
          isCurrentlyStudying: false,
          isVerified: false,
        },
      ],
      languages: [],
      createdAt: "2026-01-08T10:57:12.203Z",
      updatedAt: "2026-01-16T17:53:51.098Z",
      location: {
        city: "Abule Egba",
        state: "Lagos",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: {
        level: "BACHELOR",
        degree: "Bachelor of Arts",
        fieldOfStudy: "English Language and Literature",
        institution: "Abia State University",
      },
    },
    {
      id: "dc523d79-5e36-4b83-b81d-ced98c8c4e7f",
      firstName: "Neriah",
      lastName: "Atsu",
      email: "neriah.atsu@gmail.com",
      phone: "+234 706-440-7000",
      professionalTitle: "Software Developer/Architect & ICT Consultant",
      yearsOfExperience: 10,
      summary:
        "Highly skilled Software Developer/Architect and ICT Consultant with 10+ years of experience delivering practical ICT solutions for diverse businesses and industries. Proven ability to develop and implement applications, leveraging mathematical analysis and strategic thinking to resolve complex problems. Passionate about technology and committed to achieving impactful results.",
      city: "Lagos",
      state: "Lagos",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 3.6,
      interviewRating: null,
      cvJobMatchRating: 2.1,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: 33,
      rateStatus: "RATED",
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      isActive: true,
      skills: [
        {
          id: "a3634189-21a0-472d-b394-6404d14b614f",
          skillName: "MS-Office",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5f9aea0f-5506-44ed-81bd-d5d26b2921ad",
          skillName: "Wordpress",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5f82a5c3-90b4-41a3-9fec-553a3394345e",
          skillName: "Joomla",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "c8e2adef-701c-41e8-8591-3aaa7f654ee2",
          skillName: "Drupal",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ca7deb70-6491-4853-8c69-c7a2b82b3491",
          skillName: "3DS Max",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d2c54c88-12d0-4245-a5ed-346f69497fec",
          skillName: "Vegas Pro",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "03a8c0e1-2d6a-410a-bd59-a31cacfe0078",
          skillName: "Persistence",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5d6a7d54-999c-4602-85dd-30a0d7ceb281",
          skillName: "Patience",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d983be8e-d63f-4ce7-8358-23b440c77317",
          skillName: "Motivational Teachings",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "755e1cc5-d594-4b2d-96e1-4aaf9df4793a",
          skillName: "Instructing",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "f8d7e935-07c4-4698-8a71-dd9a039bec38",
          skillName: "Teaching",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "cafe481d-dae6-49a2-80a0-ccf4596154ba",
          skillName: "Inventing New Original Ideas",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5e0769f3-4b8b-4ad0-bbee-d4f402550fef",
          skillName: "Research",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "27a2d7b9-d951-48c0-9957-5142ea4ba714",
          skillName: "Critical Thinking",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "2777cee7-27b4-4a48-adbd-a153a8c2bf6f",
          skillName: "Complex Problem Solving",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "065ee41f-5b1b-4cbc-bd48-1c28350917af",
          skillName: "Strategic Skills",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "948e3264-6d06-4a86-94cb-1afeae358a3c",
          skillName: "Analytical Skills",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "222da0a6-c507-47fb-b558-ba69cdccce81",
          skillName: "E-Commerce Integration",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6f09e5f0-cdee-46a1-b8fd-2aaa708bfd1b",
          skillName: "Business Logic Implementation",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "862aae88-b0ec-41bf-8952-ec0b6eaeb440",
          skillName: "Business Logic Design",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "93e5f791-ad1f-4b19-b195-debed8913953",
          skillName: "Graphics Design",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ce247bbc-1ca2-450e-975f-9e2d862ec82b",
          skillName: "3D CGI Animation",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "c85fbb93-d73a-4552-bc6d-737707919e64",
          skillName: "Web Design",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6a814f22-61ca-4ada-9c6b-028fc58382de",
          skillName: "Office Applications",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "c9aa915a-430d-4d81-ac57-42472477199e",
          skillName: "Corel Draw",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "548b9d40-d426-4e4b-971b-729fb335b404",
          skillName: "Photoshop",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "c06de394-3a20-42c9-8973-4bbc5f9a2b6e",
          skillName: "Adobe Premiere",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "62a2f95d-e737-40f0-900e-f80ef04304d6",
          skillName: "JavaScript",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6204b767-6c5e-4440-ae3f-bcc6ba57578f",
          skillName: "C",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6e1c6b5a-5f68-4d26-adb5-ccf2c7dce620",
          skillName: "C++",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5815a8d5-754f-4a84-8730-7d74fb6ce2d9",
          skillName: "PHP",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "c1fcd0be-660e-4a4d-aa9b-10358714be7a",
          skillName: "C#",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6f444c74-8d75-42fb-981b-d044411b893c",
          skillName: "Python",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "1ff574d7-96c5-497e-b4b3-3d698d90950d",
          skillName: "Java",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "9044d733-58b6-46f7-a26f-347a1b7ea49a",
          skillName: "TypeScript",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "21cf9997-546a-4066-ba97-7787d31475e7",
          skillName: "Swift",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "a2425a76-86ec-4d43-aa30-2be6e54a827e",
          skillName: "Kotlin",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "53e450c7-db71-4156-9507-820caa9cbe15",
          skillName: "HTML",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "78e64ebf-0f44-4f3d-8728-bc4dc2acbad4",
          skillName: "CSS",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6d654c49-a81b-4833-a158-90ba4ce9ddbc",
          skillName: "jQuery",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "f4586708-d1c3-4539-b62b-dbbb7066557b",
          skillName: "React",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "17e6aa14-5422-49b1-816a-8c18d99a4914",
          skillName: "AJAX",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e1cfa1c7-40eb-48eb-93b0-8a0f3647a1b3",
          skillName: "Next.js",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "97be1bd1-bf8a-461b-9c49-823c76df1ffa",
          skillName: "XML",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "4738447a-1e96-4abd-9db5-248d810e013f",
          skillName: "JSON",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "12cb4283-84c0-4159-a8df-ba5907d8e912",
          skillName: "SOAP",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6bee27ff-5d02-4fcc-88a2-dd25c2510169",
          skillName: "REST",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e0b41df8-ae5a-4911-8090-2ca2160003c4",
          skillName: "Node.js",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "752453c1-0ffc-4169-924e-8a7d4e31540d",
          skillName: "Code Igniter",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "aa56840a-639f-4fd4-be24-85f87953c47e",
          skillName: "Laravel",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "44ec7c33-13c2-4313-bc11-4134e43ae66c",
          skillName: "SQL",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "944e521e-d483-437b-9273-a1aef1dd5d92",
          skillName: "MySQL",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "628df9d8-6788-453e-a1e0-e551b554127c",
          skillName: "Cassandra",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "20671a68-7759-46f5-958e-645346890a53",
          skillName: "IBM DB2",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "c547baef-dbc6-4806-a4df-b9ced024755d",
          skillName: "MSSQL",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "11e96753-4f15-4aab-b41a-2e3b479a8a02",
          skillName: "Oracle",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "9243623e-f50d-4815-be44-589a592e2c59",
          skillName: "Cloud & DevOps",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "77a2a620-023a-4b01-b18d-ebbfdcb70cc1",
          skillName: "System Administration",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5939bbbb-81ca-4a05-9e9f-ad5d3bd6f620",
          skillName: "Web App PEN Tests",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "966a893d-eec5-47ba-82fd-62efdfa525c4",
          skillName: "Windows Server",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "4b5e10a7-c902-4fbe-b59a-6c82adbfb9d5",
          skillName: "Linux Server",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "edf7ba6d-67f3-4cd6-8ff6-97f9db294f18",
          skillName: "Cordova",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "78cc7f0b-38a2-404c-af6a-4e8bfcb22e54",
          skillName: "Mathematical Analysis",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6a9b66b3-5107-434f-9b36-f66694795d1c",
          skillName: "VS-Code",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
      ],
      certifications: [],
      education: [
        {
          id: "bc920613-3db9-423a-a063-569be618adbb",
          institutionName: "Lagos State University",
          degree: "BSc. Computer Science",
          educationLevel: "BACHELOR",
          fieldOfStudy: "Computer Science",
          startDate: "2004-12-01T00:00:00.000Z",
          endDate: "2010-07-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
        {
          id: "1a15b42c-84db-47bc-bf12-939faf422d4b",
          institutionName: "Lagos City Polytechnic",
          degree: "Higher National Diploma",
          educationLevel: "ASSOCIATE",
          fieldOfStudy: "Electrical/Electronics Engineering",
          startDate: "2011-07-01T00:00:00.000Z",
          endDate: "2013-07-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
        {
          id: "63659d40-13a0-4e28-81ff-2a8f3abf5734",
          institutionName: "Lagos State Polytechnic",
          degree: "Ordinary National Diploma",
          educationLevel: "ASSOCIATE",
          fieldOfStudy: "Electrical/Electronics Engineering",
          startDate: "2004-10-01T00:00:00.000Z",
          endDate: "2007-07-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
      ],
      languages: [
        {
          id: "69976b1b-7e7d-47c7-a2c7-44894372e6d1",
          languageName: "English",
          proficiency: "NATIVE",
          isNative: true,
        },
        {
          id: "cb698a3a-9016-48dc-9ba4-776336460fc5",
          languageName: "Tiv",
          proficiency: "FLUENT",
          isNative: false,
        },
        {
          id: "bdd66325-7646-47a6-9472-d563c6e4fd14",
          languageName: "Hausa",
          proficiency: "FLUENT",
          isNative: false,
        },
        {
          id: "8b7b2afc-1f1f-4d83-8ab2-9f7c315eb3ba",
          languageName: "Yoruba",
          proficiency: "FLUENT",
          isNative: false,
        },
      ],
      createdAt: "2025-12-25T03:34:04.873Z",
      updatedAt: "2025-12-25T03:34:48.964Z",
      location: {
        city: "Lagos",
        state: "Lagos",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: {
        level: "BACHELOR",
        degree: "BSc. Computer Science",
        fieldOfStudy: "Computer Science",
        institution: "Lagos State University",
      },
    },
    {
      id: "b485d8a0-abba-4cb4-b9f3-f067cc23dc5d",
      firstName: "Keren",
      lastName: "Atsu",
      email: "emmanuel.atsu@25thmail.com",
      phone: "+234 706-440-7000",
      professionalTitle: "Software Developer/Architect & ICT Consultant",
      yearsOfExperience: 10,
      summary:
        "Highly skilled Software Developer/Architect and ICT Consultant with 10+ years of experience delivering practical ICT solutions for diverse businesses and industries. Proven ability to develop and implement applications, leveraging mathematical analysis and strategic thinking to resolve complex problems. Passionate about technology and committed to achieving impactful results.",
      city: "Lagos",
      state: "Lagos",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 3.2,
      interviewRating: null,
      cvJobMatchRating: 2,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: 32,
      rateStatus: "RATED",
      sourceChannel: "COMPANY_WEBSITE",
      tags: [],
      isActive: true,
      skills: [
        {
          id: "059c0f9f-fdfb-4fe6-933d-fd034e814057",
          skillName: "3D CGI Animation",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "09552e84-439a-4031-8e77-43be9aa98954",
          skillName: "3DS Max",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b764b596-e19e-43ed-8d2f-a58fab49719a",
          skillName: "AJAX",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ac5e6072-6b6c-4f51-8b30-a8ee90c475c6",
          skillName: "Adobe Premiere",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "17e38d57-d01f-4a3e-bcb1-1571b99300fd",
          skillName: "Analytical",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "62ea8ab6-146a-4fea-bd68-8cab62a402eb",
          skillName: "Business Logic Design",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "38fc2c5b-ed65-49e1-b0c6-b9c730032bae",
          skillName: "Business Logic Implementation",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "7c6dc676-435f-4050-b495-1dca7951386f",
          skillName: "C",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "324ee428-8336-47d4-81e8-009ad7be4e08",
          skillName: "C#",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "7ffd08c8-c72c-4af7-a55b-869e46a8288b",
          skillName: "C++",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "c52ca85e-f457-429e-8a4e-5127d04497b2",
          skillName: "CSS",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "692c53b9-bf43-4e51-9354-709bfe0e4be5",
          skillName: "Cassandra",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e51e6622-2266-43b1-9e17-7f2397ee6a31",
          skillName: "Code Igniter",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "581fa114-ec9c-4e97-a956-ab1497f7ea3c",
          skillName: "Cordova",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d59cfe49-69b2-439e-93a7-92c1cc418412",
          skillName: "Corel Draw",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "85518dfb-7b02-451f-a663-d57dbf7c447d",
          skillName: "Critical Thinking",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e6b3687b-91e0-4ce4-82ef-32b07e4d191d",
          skillName: "Drupal",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "dc54e4aa-592a-4faf-a816-2c50c9902fb9",
          skillName: "E-Commerce Integration",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "54f2b88a-d526-40a5-a1a6-eb1f35ed0a0c",
          skillName: "Graphics Design",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "196b5f97-e1fd-4e4b-86b6-684b91c37882",
          skillName: "HTML",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ffc639b8-c2a8-4f6e-8192-dd3baaa37a30",
          skillName: "IBM DB2 MSSQL",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "740cf505-f06c-4356-a407-e62ef46a2495",
          skillName: "Instructing",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "85f9d62b-3deb-4439-9017-05953b0f229c",
          skillName: "Inventing New Original Ideas",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b78478dc-6eaa-422f-9240-629595d5a533",
          skillName: "JSON",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "43cb2ca1-1a4d-4df2-aee5-11805e4696c2",
          skillName: "Java",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "8390f0a5-a976-4747-a75d-fcd0e095bdb7",
          skillName: "JavaScript",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "3d27582b-9574-423e-8522-6787fd9cb8eb",
          skillName: "Joomla",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "706bff7e-80cf-4c34-8d83-4333286c2e45",
          skillName: "Kotlin",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "3690871e-40ec-4db2-8561-a67ddc6c5ca8",
          skillName: "Laravel",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ffbfc236-ea41-4320-b7d6-b42e501953d9",
          skillName: "Linux Server",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "2a4eceaa-9697-4836-8f70-b8d511d5769e",
          skillName: "MS-Office",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "070f23b1-7de6-45cf-b154-c3e30d1debaf",
          skillName: "Mathematical Analysis",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "f8d85b90-5b9c-45dd-8650-18a04f9e5c5f",
          skillName: "Motivational Teachings",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "64f8a321-0d33-489c-89f6-b5a2f9d81aff",
          skillName: "MySQL",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "fbc5449d-0463-44e4-89df-2e0acec9ea62",
          skillName: "Next.js",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "4fd084d7-4452-4bf9-9818-30c90062bd1c",
          skillName: "Node.js",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "3a2b4d22-5968-4e08-96d7-051421a23540",
          skillName: "Office Applications",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d6c8173b-2c76-4584-b3cc-615814d38d34",
          skillName: "Oracle",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ea90c5d5-4a9e-4d6f-b11e-21a1f378d2ee",
          skillName: "PHP",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "51b392eb-e436-4744-8046-3b501d964662",
          skillName: "Patience",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "8be75435-3f0d-4ac6-9e60-b92dded9fe86",
          skillName: "Persistence",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "3d8b1b71-8e84-4ba7-ac01-7d049e019349",
          skillName: "Photoshop",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "9d3b7d36-2998-46d1-a5df-959110273e93",
          skillName: "Python",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ed16e2a1-fc2a-4b52-a3f6-4ab953a326de",
          skillName: "REST",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "9365bf9e-54ba-42e6-ac72-f77abecf40db",
          skillName: "React",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "daffa645-0bb3-44d8-8174-4cc00477f9e9",
          skillName: "Research",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "cc20cf54-ff9b-48f6-98f3-895adcbebf9a",
          skillName: "SOAP",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "54f58b75-e702-42db-a489-2c205eb965a3",
          skillName: "SQL",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "cf044ac5-df91-4355-ae06-5034fafb7809",
          skillName: "Strategic & Complex Problem Solving",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "35a94044-48d2-4df0-b4f7-70d0d1b0a216",
          skillName: "Swift",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "868d4e21-40e7-4e9d-9dc1-a0b9bf5ccc1f",
          skillName: "System Administration",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d9a478ac-cc97-4f60-851f-402a4fb8d860",
          skillName: "Teaching",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b70b2438-9d81-495e-a5ae-529d03bf7f04",
          skillName: "TypeScript",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6f8e7800-6bc0-49e9-8c47-9f7bbfe4674a",
          skillName: "VS-Code",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6b65eb0c-9584-4d8e-9378-05ee16b2d2bc",
          skillName: "Vegas Pro",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "061631ec-5946-4730-a5e2-e62cebc17e87",
          skillName: "Web App PEN Tests",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "68b760d9-7df1-43c8-8cd9-188e81e21f78",
          skillName: "Web Design",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d409295d-be07-43c8-b60f-8eb79adba04b",
          skillName: "Windows Server",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "cc28bdde-43a6-4ac2-a920-4e4c640fc29c",
          skillName: "Wordpress",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "9bee31c8-7969-4722-b65b-96485c052316",
          skillName: "XML",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "7d51aba2-0d5b-45e8-b80c-91d38203409a",
          skillName: "jQuery",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
      ],
      certifications: [],
      education: [
        {
          id: "d66f5227-bbb5-4106-b7cc-28c05046c7dd",
          institutionName: "Lagos State University",
          degree: "BSc. Computer Science",
          educationLevel: "BACHELOR",
          fieldOfStudy: "Computer Science",
          startDate: "2004-12-01T00:00:00.000Z",
          endDate: "2010-07-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
        {
          id: "091181c9-1f54-4899-975e-840124e452a7",
          institutionName: "Lagos City Polytechnic",
          degree: "HND Elect/Elect",
          educationLevel: "OTHER",
          fieldOfStudy: "Electrical/Electronics Engineering",
          startDate: "2011-07-01T00:00:00.000Z",
          endDate: "2013-07-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
        {
          id: "deb34af5-c052-4506-921d-40b50ed05370",
          institutionName: "Lagos State Polytechnic",
          degree: "OND Elect/Elect",
          educationLevel: "OTHER",
          fieldOfStudy: "Electrical/Electronics Engineering",
          startDate: "2004-10-01T00:00:00.000Z",
          endDate: "2007-07-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
      ],
      languages: [
        {
          id: "0f262afd-66ad-4c3c-ae15-844d0b19b0fd",
          languageName: "English",
          proficiency: "NATIVE",
          isNative: true,
        },
        {
          id: "5ab7f076-cb8c-4e86-a6b2-e2eca558d6e3",
          languageName: "Tiv",
          proficiency: "FLUENT",
          isNative: false,
        },
        {
          id: "1234c129-81a1-49cb-aadc-7dccdde9cb60",
          languageName: "Hausa",
          proficiency: "FLUENT",
          isNative: false,
        },
        {
          id: "ec594bd3-3362-47d8-825f-f49fa7d00ae1",
          languageName: "Yoruba",
          proficiency: "FLUENT",
          isNative: false,
        },
      ],
      createdAt: "2025-12-25T03:01:16.362Z",
      updatedAt: "2025-12-25T03:03:37.688Z",
      location: {
        city: "Lagos",
        state: "Lagos",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: {
        level: "BACHELOR",
        degree: "BSc. Computer Science",
        fieldOfStudy: "Computer Science",
        institution: "Lagos State University",
      },
    },
    {
      id: "e5c0f8f9-2a9c-450d-8c75-653e05ba651d",
      firstName: "Toheeb ",
      lastName: "Raheem",
      email: "Toheebtunde87@gmail.com",
      phone: "09133589306",
      professionalTitle: "Agile Project Manager",
      yearsOfExperience: 3,
      summary:
        "I'm an Agile Project Manager with three years of hands-on experience supporting software development teams and helping them deliver meaningful, high quality products. I've worked closely with developers, QA engineers, DevOps specialists, and product leaders to keep projects moving smoothly and to remove roadblocks before they slow teams down. I'm comfortable working in Scrum or Kanban environments, improving workflows, and helping teams build healthier delivery habits. My focus is always on clarity, communication, and results.",
      city: "Lagos",
      state: null,
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 3.1,
      interviewRating: null,
      cvJobMatchRating: 3.1,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: 53,
      rateStatus: "RATED",
      sourceChannel: "DIRECT_APPLICATION",
      tags: [],
      isActive: true,
      skills: [
        {
          id: "b07f4532-c54a-44cd-b5df-fdd28a77d9d4",
          skillName: "Velocity Tracking",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "0f61056a-3c5d-4cc8-ad92-984975ce24f6",
          skillName: "Sprint Planning",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "7b2b72ac-4186-4ab3-8597-a34047e56a69",
          skillName: "Stakeholder Management",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "548f197e-0c07-4369-8c45-1ba84fe962cc",
          skillName: "Team Coaching",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e7d9bb87-e539-4911-bfca-c5a888af0224",
          skillName: "Trello",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "7a006b0c-090e-4f2d-b699-62fac261db4f",
          skillName: "User Stories",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "801590a0-44aa-45c0-bc79-152340be63e9",
          skillName: "Agile Frameworks",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "cdb26710-7e7f-46e6-859b-e89e80484385",
          skillName: "Backlog Management",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e347abcf-6580-4f20-8d2d-0bfc891ad11d",
          skillName: "Burn-down Charts",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "10b5f218-ca49-4305-8bd2-54f8d97bffd0",
          skillName: "CI/CD Tools",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d0e2699f-04b5-4113-b066-d77e46a45899",
          skillName: "Conflict Resolution",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "0b73cb3d-add7-4f60-9967-5464aaae0a07",
          skillName: "Confluence",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5d0d106f-20de-4dba-9641-386b8aa3cfa1",
          skillName: "Cycle Time Analysis",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "660a9eb0-4d2c-4689-a49b-679d7d3276ec",
          skillName: "Facilitation",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "51ae7cd5-9db8-442f-a359-b7171cb4aec1",
          skillName: "Git",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "0f300d54-6a3d-428b-9170-32206306bea2",
          skillName: "Jira",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d422c4e2-0941-4aa6-bc6a-77bd5d4909e5",
          skillName: "Kanban",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "8d9cd1a2-95fa-4fa2-9c5f-4f99ffca4621",
          skillName: "Requirements Translation",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b238aefc-a86b-4926-89e9-06abbdeed24f",
          skillName: "Retrospectives",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "37ca39cc-bffb-49c6-8dc8-a00e695d256d",
          skillName: "SAFe",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b85e38b4-e390-451a-b33f-ccef7252ec5a",
          skillName: "SDLC",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "0d2d87e0-c208-48f9-abbb-705021a028bd",
          skillName: "Scrum",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "37d972cf-7d98-4b62-881f-8755b2b6691b",
          skillName: "API Basics",
          level: "BEGINNER",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "850f1207-b1f3-4314-b5b7-8e64bb2930ac",
          skillName: "AWS",
          level: "BEGINNER",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "efc3ce55-b559-4038-b0e9-67c279e8058a",
          skillName: "GitHub Actions",
          level: "BEGINNER",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "0d4aee8b-ecff-4c01-8b78-21e5c6e66e89",
          skillName: "GCP",
          level: "BEGINNER",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ea80b372-d805-47e0-98a3-98f17f3d96e2",
          skillName: "Jenkins",
          level: "BEGINNER",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "55aa68a0-1df4-41de-98d2-6cead9163deb",
          skillName: "GitLab",
          level: "BEGINNER",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
      ],
      certifications: [
        {
          id: "aaf9363e-e2b0-477a-a9e8-3d8ae98e074f",
          name: "Agile PM Foundation",
          issuingOrganization: "Linkedn",
          issueDate: "2022-01-01T00:00:00.000Z",
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
        {
          id: "2354252a-8ffb-471e-bb64-077bda1c02ec",
          name: "Learning Jira Software",
          issuingOrganization: "Linkedn",
          issueDate: "2022-01-01T00:00:00.000Z",
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
        {
          id: "094f3f0f-f73b-4ddc-8737-03297aaa86ae",
          name: "Risk Foundation",
          issuingOrganization: "Linkedn",
          issueDate: "2022-01-01T00:00:00.000Z",
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
        {
          id: "20f265b1-38a3-446c-a960-220cc0f05f8e",
          name: "Complete Cybersecurity",
          issuingOrganization: "StationX",
          issueDate: "2022-01-01T00:00:00.000Z",
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
      ],
      education: [
        {
          id: "878047cb-ec31-402c-8903-6cd0f908aef7",
          institutionName: "University of Ilorin",
          degree: "Bachelor of Engineering",
          educationLevel: "BACHELOR",
          fieldOfStudy: null,
          startDate: null,
          endDate: "2013-01-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
      ],
      languages: [],
      createdAt: "2025-12-22T13:16:54.789Z",
      updatedAt: "2026-01-17T13:01:33.888Z",
      location: {
        city: "Lagos",
        state: "Lagos",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: {
        level: "BACHELOR",
        degree: "Bachelor of Engineering",
        fieldOfStudy: null,
        institution: "University of Ilorin",
      },
    },
    {
      id: "cd4ca8bd-d249-47f1-875b-5a06239e47c4",
      firstName: "Daniel",
      lastName: "Doe",
      email: "zioncodex@gmail.com",
      phone: "09134641576",
      professionalTitle: "Business Manager",
      yearsOfExperience: 3,
      summary:
        "Aspiring computer scientist and leader with strong academic performance and proven leadership as Head Boy. Passionate about technology, problem-solving, and fostering innovation; digital content creation skills.",
      city: "Lagos",
      state: "Lagos",
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 2.88,
      interviewRating: 4,
      cvJobMatchRating: 1,
      manualHrRating: 3,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: 14,
      rateStatus: "RATED",
      sourceChannel: "DIRECT_APPLICATION",
      tags: [],
      isActive: true,
      skills: [
        {
          id: "907b9c82-d89b-4572-aba0-a49841d835ce",
          skillName: "Community Engagement (Discord)",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "289b0320-b6b8-40d7-941c-0fcafd16761e",
          skillName: "Computer Studies",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "61aacb51-1a16-4395-baa9-8e88f410416f",
          skillName: "Content Creation (YouTube, TikTok, Instagram)",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e956d431-7baa-4b1a-9b10-69cfa115617c",
          skillName: "Data Processing",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ce338af5-00c3-4014-a3ac-501180ce19a5",
          skillName: "Discipline",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b2b633f9-c651-4be0-b065-b9ecd490aaaf",
          skillName: "HTML",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "96576e91-754f-43a4-85e5-c8be82672854",
          skillName: "Leadership",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "042bd658-7972-46a4-b20d-5372cb0db3e3",
          skillName: "Networking (LinkedIn)",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b51fc6f0-4657-4610-830d-24d66652d036",
          skillName: "Problem-Solving",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "751a359a-f9d7-4016-9039-b936d751898e",
          skillName: "Respect",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ddd9a817-eb15-40aa-b9bc-fd34de5ce94e",
          skillName: "Teamwork",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "298660fa-c9b7-482b-9761-8aa1d6d0329a",
          skillName: "Communication",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ca60142b-b999-4d21-8600-e75d0edf5b0a",
          skillName: "CSS",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
      ],
      certifications: [
        {
          id: "29f6ad27-9f0f-4f18-83e5-3aacdcee124d",
          name: "Certificate in Effective Leadership and Good Governance",
          issuingOrganization: "Federal Ministry of Youth Development, Abuja",
          issueDate: "2025-01-01T00:00:00.000Z",
          expiryDate: null,
          doesNotExpire: false,
          isVerified: false,
        },
      ],
      education: [
        {
          id: "9ee943b2-a2ca-4914-b4aa-d22fd4fe6ffb",
          institutionName: "Linsy High School, Igbo-Efon, Lekki",
          degree: null,
          educationLevel: "HIGH_SCHOOL",
          fieldOfStudy: null,
          startDate: "2023-01-01T00:00:00.000Z",
          endDate: "2025-01-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
      ],
      languages: [],
      createdAt: "2025-12-19T12:45:38.310Z",
      updatedAt: "2026-01-23T23:30:20.101Z",
      location: {
        city: "Lagos",
        state: "Lagos",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: {
        level: "HIGH_SCHOOL",
        degree: null,
        fieldOfStudy: null,
        institution: "Linsy High School, Igbo-Efon, Lekki",
      },
    },
    {
      id: "01fca6c2-eb9d-4b2c-afce-7f20c799c770",
      firstName: "Emmanuel",
      lastName: "Atsu",
      email: "atsuemmanuel@gmail.com",
      phone: "+234706-440-7000",
      professionalTitle: "Software Developer/Architect & ICT Consultant",
      yearsOfExperience: 10,
      summary:
        "Highly skilled Software Developer/Architect and ICT Consultant with 10+ years of experience delivering practical ICT solutions for diverse businesses and industries. Proven ability to develop and implement applications, leveraging mathematical analysis and strategic thinking to resolve complex problems. Passionate about technology and committed to achieving impactful results.",
      city: "Lagos",
      state: null,
      country: "Nigeria",
      expectedSalaryMin: null,
      expectedSalaryMax: null,
      salaryCurrency: "USD",
      availableFrom: null,
      noticePeriodDays: null,
      preferredWorkArrangement: null,
      preferredEmploymentType: null,
      willingToRelocate: false,
      preferredLocations: [],
      overallRating: 2.1,
      interviewRating: null,
      cvJobMatchRating: 2.1,
      manualHrRating: null,
      experienceRating: null,
      educationRating: null,
      certificationsRating: null,
      fitScore: 33,
      rateStatus: "RATED",
      sourceChannel: "DIRECT_APPLICATION",
      tags: [],
      isActive: true,
      skills: [
        {
          id: "30e4e497-c96e-4b49-858a-30342aedfa9c",
          skillName: "Corel Draw",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "928d8b44-b8d3-4a72-99c4-3c337d3fbecd",
          skillName: "HTML",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "779d831f-5f19-4962-9ca3-852b4a0fa78c",
          skillName: "IBM DB2",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "2abe0fee-3e4a-41fc-9b96-5104903685de",
          skillName: "Instructing",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "dfe4c5b1-752b-4d9f-b0bf-ded16100b136",
          skillName: "Inventing New Original Ideas",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "8992802c-4960-4589-8680-6e8b7353804e",
          skillName: "JSON",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "cf19a5c7-f113-4460-ad29-35d4607ef4f0",
          skillName: "Java",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "80f29f08-b5cc-49a6-a859-68317c17acf6",
          skillName: "JavaScript",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "68d902de-a50b-4e45-a984-71e4520fae95",
          skillName: "Joomla",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "30f46dc3-337a-43e6-8c50-b4540625ac51",
          skillName: "Kotlin",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "057c11bb-a9b5-45a9-8139-c83024bb6638",
          skillName: "Laravel",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "511a330f-a1ec-48d8-a496-d23ea725fcce",
          skillName: "Linux Server",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "3a45e352-a88d-4281-9652-6e9a7a601cff",
          skillName: "MS-Office",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ab9dd7b3-c9f5-43eb-aa65-401a01820656",
          skillName: "MSSQL",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "7b947f73-cba8-4e8f-ad80-bbf38c354af7",
          skillName: "Mathematical Analysis",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d79ff885-421d-48f0-bb04-6bf955420d9a",
          skillName: "Motivational Teachings",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "658ad49a-f299-4166-b3ee-b7ca168c5396",
          skillName: "MySQL",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "2608550b-0fdc-4466-a482-c4acc6070908",
          skillName: "Next.js",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b581c4a1-6eef-47be-92d7-15c0f04ba65a",
          skillName: "Node.js",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6e0868c4-9e8e-4334-8400-4fb9fcfaccfe",
          skillName: "Office Applications",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "3bf2ad3e-11c3-480c-9423-d46dd7dc5184",
          skillName: "Oracle",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "bc50749e-bd04-4949-baae-85f4059dfe32",
          skillName: "PHP",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "89843228-df42-4349-86be-99fb9ec5e8ee",
          skillName: "Patience",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "9635865e-aeab-49ff-83ba-381c1ef9fc98",
          skillName: "Persistence",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "6eb0f8d4-5dae-4343-b8e7-3f696737c2b6",
          skillName: "Photoshop",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "a3cf47f2-352b-4f7a-bc61-c188d6bc70d7",
          skillName: "Python",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d5036a79-eb3f-4216-ab9d-e9874301bd7c",
          skillName: "REST",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "1ae1d925-c946-4941-a10d-23ddcf73d70c",
          skillName: "React",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "70cbb09e-7d71-4e6b-baee-d428f4df9a5e",
          skillName: "Research",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "262491c6-f871-4f7c-b041-96760b773cfb",
          skillName: "SOAP",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "2d08a451-fb93-4ae8-9012-ff3e3403e754",
          skillName: "SQL",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b43b5d90-2bf1-47f5-8803-e92933d1dbe6",
          skillName: "Strategic Skills",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "72e49ce1-d16b-41cc-88f7-618db8b7a450",
          skillName: "Swift",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "8ada8547-2b89-4c06-b42a-de2e2882bada",
          skillName: "System Administration",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5cdee155-522f-4b5b-8fa2-5f6f56a334df",
          skillName: "Teaching",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "fddf71bf-50d8-4fb9-b85c-75330cd8b1bb",
          skillName: "TypeScript",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "8f9017aa-3d29-4956-9946-3379df1504b0",
          skillName: "VS-Code",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b44c166d-00dc-41e2-9a1f-e384689e0bbc",
          skillName: "Vegas Pro",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "9f5fa500-b695-413f-8465-49f6b06727a6",
          skillName: "Web App PEN Tests",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "56dc31cd-d4df-451e-8b7b-0947ec68dfba",
          skillName: "Web Design",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "138a0f71-0f07-4186-b9fa-1785fee06110",
          skillName: "Windows Server",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "9a6508e7-407c-4166-9156-0fd80782948b",
          skillName: "Wordpress",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "61faaec8-6179-4223-9ef6-3f4f32a78f5d",
          skillName: "XML",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5f99cd1f-77e5-4a0b-9dec-b217c46c03e3",
          skillName: "jQuery",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e6d42dc8-6117-4a38-8c74-495b0a8b445a",
          skillName: "3D CGI Animation",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "b2d422a4-19b3-492d-8f40-698ebd22f388",
          skillName: "3DS Max",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "46eb2e72-aac2-4b7e-86e5-4e6b5ca80573",
          skillName: "AJAX",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "427c156f-e41d-447b-b287-eb95a66407d5",
          skillName: "Adobe Premiere",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "44243848-598a-4a42-89c3-814c388f1fe6",
          skillName: "Analytical Skills",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5f46f3f2-f1fa-41b1-9ac4-d73d4a0acf07",
          skillName: "Business Logic Design",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "53d5853b-a24c-4c5a-b366-90c03c6b7a06",
          skillName: "Business Logic Implementation",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "59d29a24-6a9a-4e88-aa04-45f414b502ff",
          skillName: "C",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "ade562a6-1977-4178-af7c-6e6c7afa79f8",
          skillName: "C#",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d8d2c108-953e-4bab-9b9c-452eae9e8f88",
          skillName: "C++",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "3662454f-56cb-4c99-9388-f1105124b6be",
          skillName: "CSS",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "e1b30346-8ba2-47b7-a091-ad27e443ebfd",
          skillName: "Cassandra",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "bfaf9505-1d0c-4943-8a7c-d0fd0c361c6f",
          skillName: "Code Igniter",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "94e97f36-cdb9-4e45-904f-bca92fd02f27",
          skillName: "Complex Problem Solving",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "16986b78-249e-4330-8097-e212d2a8f9f3",
          skillName: "Cordova",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "3e4f5bb5-0643-4692-b71c-fd89b4a088e3",
          skillName: "Critical Thinking",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "d0d6b819-de24-4562-b827-3f886849ba09",
          skillName: "Drupal",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "adbb7891-54df-4f1e-9319-81ec00423fb3",
          skillName: "E-Commerce Integration",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "83e177d0-a8bf-4c2b-baa3-ada4617245b4",
          skillName: "Graphics Design",
          level: "EXPERT",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "161a67fb-41a4-4c0b-9bd9-d049e62b4e41",
          skillName: "Cloud",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
        {
          id: "5c238799-d5d7-4173-8ffc-eb7fa4c77c8f",
          skillName: "DevOps",
          level: "INTERMEDIATE",
          yearsOfExperience: null,
          lastUsedYear: null,
        },
      ],
      certifications: [],
      education: [
        {
          id: "f7d114d7-a230-4ad7-b8e6-a104db1d9039",
          institutionName: "Lagos State University",
          degree: "BSc. Computer Science",
          educationLevel: "BACHELOR",
          fieldOfStudy: "Computer Science",
          startDate: "2004-12-01T00:00:00.000Z",
          endDate: "2010-07-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
        {
          id: "43fbdb2b-1ef1-49b0-bb01-002ef8c9efdd",
          institutionName: "Lagos City Polytechnic",
          degree: "Higher National Diploma (HND)",
          educationLevel: "OTHER",
          fieldOfStudy: "Electrical/Electronics Engineering",
          startDate: "2011-07-01T00:00:00.000Z",
          endDate: "2013-07-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
        {
          id: "f90e78db-9030-4730-a720-d3087710ce2e",
          institutionName: "Lagos State Polytechnic",
          degree: "Ordinary National Diploma (OND)",
          educationLevel: "OTHER",
          fieldOfStudy: "Electrical/Electronics Engineering",
          startDate: "2004-10-01T00:00:00.000Z",
          endDate: "2007-07-01T00:00:00.000Z",
          isCurrentlyStudying: false,
          isVerified: false,
        },
      ],
      languages: [
        {
          id: "37616aa2-c5f4-4d25-8804-eb30c5a93999",
          languageName: "English",
          proficiency: "NATIVE",
          isNative: true,
        },
        {
          id: "9600688e-51d7-43d0-b6c2-cd588cb3777e",
          languageName: "Tiv",
          proficiency: "FLUENT",
          isNative: false,
        },
        {
          id: "26e0f6a0-2b9c-4a04-bf3b-4f6f6e2c1f16",
          languageName: "Hausa",
          proficiency: "FLUENT",
          isNative: false,
        },
        {
          id: "e05a833a-e580-44b5-9951-54de325aefbe",
          languageName: "Yoruba",
          proficiency: "FLUENT",
          isNative: false,
        },
      ],
      createdAt: "2025-12-17T23:17:46.643Z",
      updatedAt: "2026-01-23T18:59:47.103Z",
      location: {
        city: "Lagos",
        state: "Lagos",
        country: "Nigeria",
      },
      expectedSalaryRange: null,
      availabilityStatus: "UNKNOWN",
      highestEducation: {
        level: "BACHELOR",
        degree: "BSc. Computer Science",
        fieldOfStudy: "Computer Science",
        institution: "Lagos State University",
      },
    },
  ],
  pagination: {
    page: 1,
    pageSize: 15,
    totalCount: 13,
    totalPages: 2,
    hasNextPage: true,
    hasPreviousPage: false,
  },
};
